/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/1152g05j/screen/67851869
 */

import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Icon from '@components/@core/Icon';
import Thumbnail from '@components/@core/Thumbnail';
import ProductRating from './ProductRating';
import { hasHtml } from '~/services/util';
import AppActions from '~/actions/app';

const PlusShow = ({ data }) => {
    const dispatch = useDispatch();

    const { media, videos } = data;

    const handlePreviewMedia = () => {
        dispatch(
            AppActions.modalRequest({
                type: 'Premium Media View',
                data: { before: { videos, medias: media, selected: 0 } },
            })
        );
    };

    return (
        <>
            <div className="d-flex align-items-end mb-4">
                <span className="dsl-b24 bold">{data.name}</span>
            </div>
            <div className="d-flex">
                <div className="d-flex-1">
                    <ProductRating className="pb-4 border-bottom" data={data} />
                    <p className="dsl-b20 bold mt-4">Contact</p>
                    <div className="contact mt-4">
                        <Icon name="fas fa-phone-alt head" color="dark" size={14} />
                        {data.data?.contact?.phone ? (
                            <a className="dsl-b16 info" href={`tel:${data.data?.contact?.phone}`}>
                                {data.data?.contact?.phone}
                            </a>
                        ) : (
                            <span className="dsl-b16">Not provided</span>
                        )}
                    </div>
                    <div className="contact mt-4">
                        <Icon name="fas fa-window-maximize head" color="dark" size={14} />
                        {data.data?.website ? (
                            <a className="dsl-b16 info" href={data.data?.website} target="_blank">
                                {data.data?.website}
                            </a>
                        ) : (
                            <span className="dsl-b16">Not provided</span>
                        )}
                    </div>
                    <div className="contact mt-4">
                        <Icon name="fas fa-envelope head" color="dark" size={14} />
                        {data.data?.contact?.email ? (
                            <a className="dsl-b16 info" href={`mailto:${data.data?.contact?.email}`}>
                                {data.data?.contact?.email}
                            </a>
                        ) : (
                            <span className="dsl-b16">Not provided</span>
                        )}
                    </div>
                </div>
                <div className="d-flex-3 ms-5">
                    <div className="video-section w-50">
                        <div className={`video-card ${data.media[0]?.data?.file_path ? '' : 'empty'}`} onClick={handlePreviewMedia}>
                            <Thumbnail source={data.media[0]?.data?.file_path} defaultImg="/images/profile/products/0.png" size="responsive" ratioType="5" />
                            <div className="controls d-h-center">
                                <Icon name="fas fa-search" size={40} color="#376caf" />
                            </div>
                        </div>
                    </div>
                    <p className="dsl-b18 bold mt-4">About</p>
                    {hasHtml(data.data?.description ?? '') ? (
                        <div className="about-section" dangerouslySetInnerHTML={{ __html: data.data.description }} />
                    ) : (
                        <div className="about-section">
                            <p className="dsl-b16">{data.data?.description}</p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

PlusShow.propTypes = {
    data: PropTypes.any,
    title: PropTypes.string,
};

PlusShow.defaultProps = {
    data: {},
    title: 'HCM',
};

export default PlusShow;
